import { StarFilled } from '@ant-design/icons';
import { Rate } from 'antd';
import React from 'react';

interface StarRatingProps {
  rating: number;
  color: string;
  starSize?: string;
  showEmptyStars?: boolean;
  count?: number;
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  color,
  starSize = '16px',
  showEmptyStars = false,
  count = 5,
}) => {
  const getStarIcon = (index: number): React.ReactNode => {
    if (index + 1 <= rating) {
      return <StarFilled style={{ color, fontSize: starSize }} />;
    }
    if (index + 0.5 <= rating) {
      return (
        <StarFilled
          style={{ color, fontSize: starSize, clipPath: 'inset(0 50% 0 0)' }}
        />
      );
    }
    return showEmptyStars ? (
      <StarFilled style={{ color: '#FFFFFF33', fontSize: starSize }} />
    ) : null;
  };

  return (
    <Rate
      allowHalf
      value={rating}
      character={({ index }) => getStarIcon(index!)}
      disabled
      count={showEmptyStars ? count : Math.ceil(rating)}
    />
  );
};

export default StarRating;
